<ng-container *ngFor="let item of fields; let i = index">
    <td [innerHTML]="getFieldValue(item, i)" (click)="selectItem.emit(data)"></td>
</ng-container>